import { render, staticRenderFns } from "./beautifulHometown.vue?vue&type=template&id=f2b12b64&scoped=true"
import script from "./beautifulHometown.vue?vue&type=script&lang=js"
export * from "./beautifulHometown.vue?vue&type=script&lang=js"
import style0 from "./beautifulHometown.vue?vue&type=style&index=0&id=f2b12b64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2b12b64",
  null
  
)

export default component.exports